<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :row-height="60" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <BjFormItemCode v-model="queryParams.supplierCode" :label="$t('BusinessPurchaseSupplierShop.header.code')" prop="supplierCode" @keyup.enter.native="handleQuery" />
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseSupplierShop.header.name')" prop="supplierName">
            <BjInput v-model="queryParams.supplierName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="colSpan">
          <el-form-item label="供应商分类" prop="supplierType">
            <BjInput
              v-model="queryParams.supplierType"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseSupplierShop.header.package')" prop="packagingFlag">
            <BjSelectLov v-model="queryParams.packagingFlag" :option-list="STATUS_YES_TRUE" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseSupplierShop.header.free')" prop="shippingFlag">
            <BjSelectLov v-model="queryParams.shippingFlag" :option-list="STATUS_YES_TRUE" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemCode v-model="queryParams.supplierSpuCode" :label="$t('BusinessPurchaseSupplierShop.header.commodityCode1')" prop="supplierSpuCode" @keyup.enter.native="handleQuery" />
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemCode v-model="queryParams.supplierSkuCode" :label="$t('BusinessPurchaseSupplierShop.header.sku')" prop="supplierSkuCode" @keyup.enter.native="handleQuery" />
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemCode v-model="queryParams.spuCode" :label="$t('BusinessPurchaseSupplierShop.header.commodityCode2')" prop="spuCode" @keyup.enter.native="handleQuery" />
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemCode v-model="queryParams.skuCode" :label="$t('BusinessPurchaseSupplierShop.header.skuCode')" prop="skuCode" @keyup.enter.native="handleQuery" />
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('table.createTimeText')"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button v-permission:BusinessPurchaseSupplierShopIndex_Add type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
          <el-button v-permission:BusinessPurchaseSupplierShopIndex_ExcelImport type="primary" @click="onImport">{{ $t('BusinessPurchaseSupplierShop.export.excelImport') }}</el-button>
          <el-button v-permission:BusinessPurchaseSupplierShopIndex_Edit type="primary" :disabled="tableOperationProp.notSingle" @click="onEdit">{{ $t('BusinessPurchaseSupplierShop.export.modify') }}</el-button>
          <el-button v-permission:BusinessPurchaseSupplierShopIndex_Delete type="primary" :disabled="tableOperationProp.notSelected" @click="onDeleteSelected">{{ $t('delText') }}</el-button>
          <el-button v-permission:BusinessPurchaseSupplierShopIndex_Export type="primary" @click="onExport">{{ $t('BusinessPurchaseSupplierShop.export.export') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="{ row }">
              <template v-if="false" />
              <div v-else-if="col.prop === 'spuPic'" class="flex flex-center">
                <BjViewUrl v-if="row.spuPic && row.spuPic!== 'null'" :url="(row[col.prop])" height="50px" preview />
              </div>
              <el-tag v-else-if="
                  ['packagingFlag', 'shippingFlag'].includes(col.prop) && row[col.prop] != null
                " :type="row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_YES_TRUE.bjGet(row[col.prop])) }}</el-tag>
              <template v-else-if="col.prop === 'deliveryCycleDay' && row[col.prop] != null">
                {{ row[col.prop] }}{{ $t('BusinessPurchaseSupplierShop.export.day') }}
              </template>
              <template v-else-if="col.prop === 'taxRate' && row[col.prop] != null">
                {{ row[col.prop] }}%
              </template>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
    <BjExcelImportDialog ref="ExcelImport" :download-name="$t('BusinessPurchaseSupplierShop.export.title')" template-code="SPUR.SUPPLIER_GOODS_IMPORT">
      <p>{{ $t('ExcelConfig.Import') }}</p>
      <div class="text">
        1.{{ $t('ExcelConfig.AfterDownload') }}<br />
        2.{{ $t('ExcelConfig.ImportExcel') }}
        <el-button type="primary" @click="onDownload">{{ $t('ExcelConfig.Download') }}</el-button><br />
        3.{{ $t('ExcelConfig.MustHave') }}<br />
        4.{{ $t('ExcelConfig.Supports') }}<br />
      </div>
    </BjExcelImportDialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi, importApi } from '@/api';
import { STATUS_YES_TRUE } from '@/utils/constants';
import DataForm from './components/DataForm.vue';
import { downloadBlob } from '@/utils/index';

export default {
  name: 'BusinessPurchaseSupplierShop',
  components: { DataForm },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_YES_TRUE,
      queryApi: purchaseApi.getSupplierGoodss,
      // 查询参数
      queryParamsTime: null,
      queryParams: {
        supplierCode: null,
        supplierName: null,
        supplierType: null,
        createTimeBegin: null,
        createTimeEnd: null,
        supplierSpuCode: null,
        supplierSkuCode: null,
        spuCode: null,
        skuCode: null,
        packagingFlag: null,
        shippingFlag: null,
      },
      labelsVersion: 0,
      labelList: [
        { label: 'BusinessPurchaseSupplierShop.table.picture', prop: 'spuPic', isCheck: true, disabled: false, width: 160 },
        // { label: 'goodsPage.spuCode', prop: 'spuCode', isCheck: true, disabled: false, width: 160 },
        // { label: 'goodsPage.spuName', prop: 'spuName', isCheck: true, disabled: false, width: 160 },
        { label: 'BusinessPurchaseSupplierShop.table.sku', prop: 'skuCode', isCheck: true, disabled: false, width: 160 },
        { label: 'BusinessPurchaseSupplierShop.table.skuName', prop: 'skuName', isCheck: true, disabled: false, width: 160 },
        { label: 'BusinessPurchaseSupplierShop.table.supplierCode', prop: 'supplierCode', isCheck: true, disabled: false, width: 160 },
        { label: 'BusinessPurchaseSupplierShop.table.supplierName', prop: 'supplierName', isCheck: true, disabled: false, width: 160 },
        // { label: '品牌', prop: '', isCheck: true, disabled: false, width: 120 },
        // { label: '分类', prop: '', isCheck: true, disabled: false, width: 120 },
        { label: 'BusinessPurchaseSupplierShop.table.taxUnitPrice', prop: 'taxUnitPrice', isCheck: true, disabled: false, width: 110 },
        { label: 'BusinessPurchaseSupplierShop.table.unitPrice', prop: 'unitPrice', isCheck: true, disabled: false, width: 120 },
        { label: 'BusinessPurchaseSupplierShop.table.taxRate', prop: 'taxRate', isCheck: true, disabled: false, width: 100 },
        {
          label: 'BusinessPurchaseSupplierShop.table.supplierSpuCode',
          prop: 'supplierSpuCode',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        {
          label: 'BusinessPurchaseSupplierShop.table.supplierSkuCode',
          prop: 'supplierSkuCode',
          isCheck: true,
          disabled: false,
          width: 160,
        },
        { label: 'BusinessPurchaseSupplierShop.table.package', prop: 'packagingFlag', isCheck: true, disabled: false, width: 135 },
        { label: 'BusinessPurchaseSupplierShop.table.shipping', prop: 'shippingFlag', isCheck: true, disabled: false, width: 110 },
        { label: 'BusinessPurchaseSupplierShop.table.minQty', prop: 'minQty', isCheck: true, disabled: false, width: 140 },
        { label: 'BusinessPurchaseSupplierShop.table.week', prop: 'deliveryCycleDay', isCheck: true, disabled: false, width: 110 },
        { label: 'BusinessPurchaseSupplierShop.table.remark', prop: 'remark', isCheck: true, disabled: false, width: 160 },
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: 140 },
        { label: 'table.creatorText', prop: 'createdName', isCheck: true, disabled: false, width: 100 },
        { label: 'BusinessPurchaseSupplierShop.table.updateDate', prop: 'lastUpdateDate', isCheck: true, disabled: false, width: 140 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129 },
      ],
    };
  },
  computed: {},
  watch: {
    queryParamsTime(v) {
      this.queryParams.createTimeBegin = (v || [])[0];
      this.queryParams.createTimeEnd = (v || [])[1];
    },
  },
  mounted() {},
  methods: {
    onDownload() {
      const data = {templateCode: 'SPUR.SUPPLIER_GOODS_IMPORT', tenantId: 0};
      importApi['exportExcelImportTemplateHeaders'](data).then(res => {
        downloadBlob(res, `采购供应商商品导入.xlsx`);
      });
    },
    beforeResetSearch() {
      this.queryParamsTime = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 新增 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit() {
      const { id } = this.selectedRows[0];
      purchaseApi.getSupplierGoodssDetail({ id }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$refs.DataForm.show(this.$lodash.clone(res));
        }
      });
    },
    /** 删除 */
    /** 批量删除操作 */
    onDeleteSelected() {
      this.$MessageBox({ content: this.$t('toast.deletionConfirmationText') }).then(() => {
        const ids = this.selectedRows.map(e => {
          const { id, objectVersionNumber } = e;
          return {
            id,
            objectVersionNumber,
          };
        });
        this.batchDeleteApi({
          ids,
        });
      });
    },
    /** 导入 */
    onImport() {
      this.$refs.ExcelImport.show();
    },
    /** 导出 */
    onExport() {
      purchaseApi.reportSupplierGoodss(this.queryParams).then(res => {
        downloadBlob(res, this.$t('BusinessPurchaseSupplierShop.export.productExport') + new Date().toLocaleString() + '.xlsx');
      });
    },
    batchDeleteApi(ids) {
      purchaseApi.deleteSupplierGoodss(ids).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
